<template>
  <IconWrapper name="warning" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6279 3.35309C11.9877 2.59902 13.7174 3.09447 14.4773 4.44209L21.746 17.0572C21.906 17.4338 21.976 17.7399 21.996 18.058C22.036 18.8012 21.776 19.5236 21.2661 20.0795C20.7562 20.6334 20.0663 20.9604 19.3164 21H4.6789C4.36896 20.9812 4.05901 20.9108 3.76906 20.8018C2.3193 20.2172 1.61942 18.5723 2.20932 17.1464L9.52809 4.43317C9.77804 3.98628 10.158 3.60082 10.6279 3.35309ZM11.9977 15.2726C11.5178 15.2726 11.1178 15.669 11.1178 16.1456C11.1178 16.6202 11.5178 17.0176 11.9977 17.0176C12.4776 17.0176 12.8675 16.6202 12.8675 16.1347C12.8675 15.66 12.4776 15.2726 11.9977 15.2726ZM11.9977 9.09039C11.5178 9.09039 11.1178 9.47585 11.1178 9.95248V12.7557C11.1178 13.2314 11.5178 13.6287 11.9977 13.6287C12.4776 13.6287 12.8675 13.2314 12.8675 12.7557V9.95248C12.8675 9.47585 12.4776 9.09039 11.9977 9.09039Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
}>()
</script>
